import React, { useState, useContext } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import CallEnd from '@material-ui/icons/CallEnd';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import CallDisconnectModal from './CallDisconnectModal/CallDisconnectModal';
import { axClient } from '../../../axiosClient';
import { ToolBarContext } from '../../../App';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
  })
);

export default function EndCallButton({ userType }) {
  const classes = useStyles();
  const { room } = useVideoContext();
  const [endCallModal, setEndCallModal] = useState(false);
  const {
    room: { localParticipant },
    sendDataToParticipants,
  } = useVideoContext();
  const { setMeetingEnded } = useContext(ToolBarContext);

  const disconnectCall = (forAll?: boolean) => {
    if (userType === 'host') {
      sessionStorage.removeItem('token');
      axClient.post('/event', {
        event_type: 'ended',
      });
      sendDataToParticipants(
        JSON.stringify({
          type: 'END_MEETING',
          data: {
            isMeeting_Ended: true,
          },
        })
      );
    } else {
      axClient.post('/event', {
        event_type: 'participant_left',
        event_data: { username: localParticipant.identity },
      });
    }
    setMeetingEnded(true);
    room.disconnect();
  };

  return (
    <>
      <Tooltip
        title={'End Call'}
        onClick={() => setEndCallModal(true)}
        placement="top"
        PopperProps={{ disablePortal: true }}
      >
        <Fab className={classes.fab} color="secondary">
          <CallEnd />
        </Fab>
      </Tooltip>
      {setEndCallModal && (
        <CallDisconnectModal
          showModal={endCallModal}
          setShowModal={setEndCallModal}
          disconnectCall={disconnectCall}
          userType={userType}
        />
      )}
    </>
  );
}
